/**
 * Created by Ram on 3/04/2017.
 */

import React, { Component } from 'react';
import TestInstanceManagement from '../presentation/TestInstanceManagement';
import dynamicSort from '../../logic/DynamicSort';

class TestInstanceManagementWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            testInstances: [],
            success: '',
            errorField: '',
            serverError: '',
            error: '',
            testInstance: '',
            devices: [],
            scenarioName: '',
            scenarioEnvironment: '',
            scenarioDeviceDPH: '',
            startStopTest: 'Start Test Instance',
            displayEdit: true,
            displayButton: true,
            state: '',
            comments: '',
            search: '',
            sort: 'creationTime',
            sortAsc: false,
            sortDevices: 'name',
            sortDevicesAsc: true,
            currentInstance: '',
        };

        this.isUnmounting = false;
    }

    componentDidMount() {
        this.getTestInstanceList();
    }

    getTestInstanceList() {
        if (!this.isUnmounting) {
            this.setState({ isLoading: true, testInstances: [] }, () => {
                fetch('/service/testInstanceList?search=' + this.state.search, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    credentials: 'same-origin',
                })
                    .then(response => {
                        if (response.status !== 200) {
                            this.setState({
                                error: 'An error has occurred fetching test instance details',
                                isLoading: false,
                            });
                        } else {
                            response.json().then(testInstances => {
                                let testInstancesMapped = testInstances.map(testInstance => {
                                    testInstance.runningStatus = this.checkTestState(testInstance);
                                    testInstance.numberDevices = testInstance.devices.length;
                                    return testInstance;
                                });

                                let testInstancesSorted = testInstancesMapped.sort(
                                    dynamicSort(this.state.sort, this.state.sortAsc ? 1 : -1),
                                );
                                this.setState({
                                    testInstances: testInstancesSorted,
                                    isLoading: false,
                                });

                                if (testInstances.length) {
                                    this.getSingleTestInstance(testInstancesSorted[0]._id);
                                }
                            });
                        }
                    })
                    .catch(console.error);
            });
        }
    }

    checkTestState = testInstance => {
        if (!this.isUnmounting) {
            let startTime = testInstance.startTime;
            let endTime = testInstance.endTime;
            let error = false;
            let ready = true;
            let devicesState = Object.values(testInstance.devices);

            devicesState.map(deviceState => {
                if (deviceState['batteryReady'] != undefined) {
                    if (!deviceState['batteryReady']) {
                        ready = false;
                    }
                }

                if (deviceState['hostReady'] != undefined) {
                    if (!deviceState['hostReady']) {
                        ready = false;
                    }
                }

                if (deviceState['error']) {
                    error = true;
                }
            });

            if (startTime) {
                if (endTime) {
                    if (error) {
                        this.setState({
                            startStopTest: 'Start Test Instance',
                            displayEdit: false,
                            displayButton: false,
                            state: 'Error',
                        });
                    } else {
                        if (!ready) {
                            this.setState({
                                startStopTest: 'Start Test Instance',
                                displayEdit: false,
                                displayButton: false,
                                state: 'Finished',
                            });
                        } else {
                            this.setState({
                                startStopTest: 'Start Test Instance',
                                displayEdit: false,
                                displayButton: false,
                                state: 'Completed',
                            });
                        }
                    }
                } else {
                    if (error) {
                        this.setState({
                            startStopTest: 'Stop Test Instance',
                            displayEdit: false,
                            displayButton: true,
                            state: 'Error',
                        });
                    } else {
                        if (!ready) {
                            this.setState({
                                startStopTest: 'Stop Test Instance',
                                displayEdit: false,
                                displayButton: true,
                                state: 'Initialising',
                            });
                        } else {
                            this.setState({
                                startStopTest: 'Stop Test Instance',
                                displayEdit: false,
                                displayButton: true,
                                state: 'In Progress',
                            });
                        }
                    }
                }
            } else {
                this.setState({
                    startStopTest: 'Start Test Instance',
                    displayEdit: true,
                    displayButton: true,
                    state: 'Planned',
                });
            }
        }
    };

    getTestInstanceDevices = testInstance => {
        if (!this.isUnmounting) {
            let devices = [];
            this.setState({ currentInstance: testInstance });

            testInstance.devices.map(testDevice => {
                devices.push(testDevice.deviceId);
            });

            fetch(
                '/service/getClusterDevices?devices=' +
                    devices +
                    '&sortDevices=' +
                    this.state.sortDevices +
                    '&sortDevicesAsc=' +
                    this.state.sortDevicesAsc,
                {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    credentials: 'same-origin',
                },
            ).then(response => {
                if (response.status === 200) {
                    response.json().then(devices => {
                        this.setState({ devices });
                    });
                }
            });
        }
    };

    refreshDeviceList = () => {
        this.getSingleTestInstance(this.state.currentInstance._id);
    };

    getScenarioDetails = testInstance => {
        if (!this.isUnmounting) {
            let scenarioId = testInstance.scenarioId;

            if (scenarioId !== null && scenarioId !== '') {
                fetch('/service/getScenarioDetails?scenarioId=' + scenarioId, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    credentials: 'same-origin',
                }).then(response => {
                    if (response.status !== 200) {
                        this.setState({
                            error: 'An error has occurred fetching scenario name',
                        });
                    } else {
                        response.json().then(json => {
                            this.setState({
                                scenarioName: json.name,
                                scenarioEnvironment: json.environment,
                                scenarioDeviceDPH : json.deviceDPH,
                            });
                        });
                    }
                });
            } else {
                this.setState({ scenarioName: '', scenarioEnvironment: '', scenarioDeviceDPH: '' });
            }
        }
    };

    getSingleTestInstance = testInstanceId => {
        if (!this.isUnmounting) {
            fetch('/service/getSingleTestInstanceDetails?testInstanceId=' + testInstanceId, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            }).then(response => {
                if (response.status !== 200) {
                    this.setState({
                        error: 'An error has occurred fetching single test instance details',
                    });
                } else {
                    response.json().then(testInstance => {
                        this.setState({
                            testInstance,
                            comments: testInstance.comments,
                            success: '',
                            serverError: '',
                        });
                        this.getScenarioDetails(testInstance);
                        this.getTestInstanceDevices(testInstance);
                        this.checkTestState(testInstance);
                    });
                }
            });
        }
    };

    updateComments = comments => {
        const body = {
            comments: comments,
            testInstanceId: this.state.testInstance._id,
        };

        fetch('/service/editTestInstanceComments', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify(body),
        }).then(response => {
            if (response.status === 200) {
                console.log(' Comments saved successfully.');
            } else {
                console.log('Error saving comments: response code ' + response.status);
            }
        });
    };

    showEditTestInstance = testInstanceId => {
        this.props.navigator.requestEditTestInstance(testInstanceId);
    };

    cloneTestInstance = testInstanceId => {
        this.props.navigator.requestAddNewTestInstance(testInstanceId);
    };

    startStopInstance = id => {
        let startStopTest = this.state.startStopTest;

        let result = startStopTest.match(/Start/g);
        let startStopTestInstance;

        if (result) {
            startStopTestInstance = 'startTestInstance';
        } else {
            startStopTestInstance = 'stopTestInstance';
            if (confirm('Are you sure you want to stop this test?')) {
                this.setState({ displayButton: 'false' });
            } else {
                return;
            }
        }

        const body = {
            _id: this.state.testInstance._id,
        };

        fetch('/service/' + startStopTestInstance, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify(body),
        }).then(response => {
            response.json().then(json => {
                if (json['isDeviceRunning']) {
                    alert('Another Test instance is running devices which are part of this test instance.');
                    return;
                }
                setTimeout(() => {
                    // Resolve issue with WriteConcern on UAT3.
                    this.setState({ startStopTest: 'Stop Test Instance' });
                    this.getSingleTestInstance(id);
                    this.getTestInstanceList();
                }, 50);
            });
        });
    };

    updateSearchState = e => {
        if (!this.isUnmounting) {
            this.setState({ search: e.target.value }, () => {
                this.getTestInstanceList();
            });
        }
    };

    updateSortState = sortBy => {
        if (!this.isUnmounting) {
            if (sortBy === this.state.sort) {
                this.setState(prevState => ({ sortAsc: !prevState.sortAsc }), this.getTestInstanceList);
            } else {
                this.setState({ sort: sortBy }, this.getTestInstanceList);
            }
        }
    };

    updateDevicesSortState = sortBy => {
        if (!this.isUnmounting) {
            const callback = () => this.getTestInstanceDevices(this.state.currentInstance);
            if (sortBy === this.state.sortDevices) {
                this.setState(prevState => ({ sortDevicesAsc: !prevState.sortDevicesAsc }), callback);
            } else {
                this.setState({ sortDevices: sortBy }, callback);
            }
        }
    };

    deleteTestInstance = testInstanceId => {
        if (confirm('Are you sure you want to delete this test instance?')) {
            fetch('/service/deleteTestInstance', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({ testInstanceId: testInstanceId }),
            }).then(response => {
                if (response.status === 200) {
                    this.getTestInstanceList();
                }else{
                    alert("Failed to delete test instance. It may be in progress or already deleted.")
                }
            });
        }
    };

    componentWillUnmount() {
        this.isUnmounting = true;
    }

    render() {
        return (
            <TestInstanceManagement
                navigator={this.props.navigator}
                loadData={this.state}
                getSingleTestInstance={this.getSingleTestInstance}
                getDeviceList={this.getDeviceList}
                showEditTestInstance={this.showEditTestInstance}
                cloneTestInstance={this.cloneTestInstance}
                startStopInstance={this.startStopInstance}
                updateSearchState={this.updateSearchState}
                checkTestState={this.checkTestState}
                updateFormState={this.updateFormState}
                updateSortState={this.updateSortState}
                updateDevicesSortState={this.updateDevicesSortState}
                updateComments={this.updateComments}
                deleteTestInstance={this.deleteTestInstance}
                refreshDeviceList={this.refreshDeviceList}
            />
        );
    }
}

export default TestInstanceManagementWidget;
